// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__uqD86","options":"AnswerScale_options__1Z7hM","selected":"AnswerScale_selected__1mzGx"};